import { render, staticRenderFns } from "./FormTabs.vue?vue&type=template&id=51eda880&scoped=true&"
import script from "./FormTabs.vue?vue&type=script&lang=js&"
export * from "./FormTabs.vue?vue&type=script&lang=js&"
import style0 from "./FormTabs.vue?vue&type=style&index=0&id=51eda880&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51eda880",
  null
  
)

export default component.exports